import { useEffect, useState } from "react";
import { useFormContext } from "react-hook-form";
import { IOperatorSchema } from "../../interfaces/endpoints/IOperators";
import SuperAdmin from "../users/permissions/SuperAdmin";

const OperatorCommissionFeeInput: React.FC = () => {
  const { register, formState: { errors, isLoading: formLoading }, setValue, watch }
   = useFormContext<IOperatorSchema>();
   const [isLoading, setIsLoading] = useState(true);
   const commissionFee = watch("commissionFee");

   useEffect(() => {
     if (!commissionFee?.fee && commissionFee?.fee !== 0) {
       setValue("commissionFee", undefined);
       setIsLoading(false);
       return;
     }

     if (commissionFee?.fee !== undefined
      && commissionFee.fee !== null
      && commissionFee.fee < 100
      && Number((commissionFee.fee * 100).toFixed(4)) < 100) {
       const percentageValue = Number((commissionFee.fee * 100).toFixed(4));
       setValue("commissionFee.fee", percentageValue, { shouldValidate: true });
     }
     setTimeout(() => setIsLoading(false), 1500);
   }, [commissionFee]);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      e.key === "Backspace" ||
      e.key === "Delete" ||
      e.key === "Tab" ||
      e.key === "Escape" ||
      e.key === "Enter" ||
      e.key === "."
    ) {
      if (e.key === "." && (e.target as HTMLInputElement).value.includes(".")) {
        e.preventDefault();
      }
      return;
    }

    if (!/[\d]/.test(e.key)) {
      e.preventDefault();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let value = e.target.value;

    // If empty, set commission fee to null
    if (!value) {
      setValue("commissionFee", undefined);
      return;
    }

    value = value.replace(/[^\d.]/g, "");

    const parts = value.split(".");
    if (parts.length > 2) {
      value = parts[0] + "." + parts.slice(1).join("");
    }

    if (value.includes(".")) {
      const [whole, decimal] = value.split(".");
      value = `${whole}.${decimal.slice(0, 4)}`;
    }

    e.target.value = value;
  };

  return (
    <SuperAdmin>
      <div className="flex flex-col space-y-2 w-1/2">
        <label htmlFor="commissionFee" className="text-neutral block
        text-sm leading-[17px] whitespace-nowrap">
          Komisioni (%)
        </label>
        <div className="relative">
          {isLoading ? (
            <div className="flex items-center">
              <div className="h-10 bg-gray-100 animate-pulse rounded-lg w-full py-3"></div>
              <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                <span className="text-gray-400">%</span>
              </div>
            </div>
          ) : (
            <>
              <input
                type="text"
                id="commissionFee"
                {...register("commissionFee.fee")}
                onKeyDown={handleKeyDown}
                onChange={handleChange}
                placeholder="0.00"
                className={`block w-full px-2 py-2.5 border ${
                  errors.commissionFee?.fee ? "border-red-500" : "border-gray-300"
                } rounded-lg shadow-sm focus:ring-primary focus:border-primary sm:text-sm`}
              />
              <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                <span className="text-gray-500">%</span>
              </div>
            </>
          )}
        </div>
        {errors.commissionFee?.fee && !formLoading && (
          <p className="text-sm text-red-500">
            {errors.commissionFee.fee.message}
          </p>
        )}
        <p className="text-sm text-gray-500">
          Shkruani një vlerë midis 0.00% dhe 100.00% që
          paraqet përqindjen e komisionit të operatorit
        </p>
      </div>
    </SuperAdmin>
  );
};

export default OperatorCommissionFeeInput;
